import React from 'react';
import { TICKET_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY } from 'config/CustomEnums';

import EventPreviewContentCard from 'components/Events/EventPreviewContentCard';
import EventPreviewPropertiesCard from 'components/Events/EventPreviewPropertiesCard';


export const EVENT_DETAIL_PAGE_CONFIG = {
  extraValidate: () => true,
  getDisplayComponentKeys: ({ detailData }) => {
    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents: ["content_section_key", "properties_section_key"]
    };
  },
  normalSections: [],
  languageSections: [
    {
      sectionKey: TICKET_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.content.sectionKey,
      sectionContent: [
        {
          key: "content_section_key",
          complexComponent: ({ detailData, language }) => (
            <EventPreviewContentCard
              language={language}
              campaignData={detailData}
              hideEditButton
            />
          ),
        },
      ],
    },
    {
      sectionKey: TICKET_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.properties.sectionKey,
      sectionTitle: "Rule & properties",
      sectionContent: [
        {
          key: "properties_section_key",
          complexComponent: ({ detailData, language }) => (
            <EventPreviewPropertiesCard
              language={language}
              campaignData={detailData}
              hideEditButton
            />
          ),
        },
      ],
    },
  ],
}